// Hebrew display names for sizes. Underlying size keys stay in Spanish
// so stock lookups (stock_qty) and order payloads remain consistent.
const HE_SIZE = [
  ['Extra Grande', 'גדול במיוחד'],
  ['Grande', 'גדול'],
  ['Adulto', 'מבוגר'],
  ['Adult', 'מבוגר'],
  ['Niño', 'ילד'],
  ['Boys', 'ילדים'],
  ['Standard', 'סטנדרטי'],
];

export const displaySize = (size, language) => {
  if (language !== 'he' || typeof size !== 'string') return size;
  let out = size;
  for (const [es, he] of HE_SIZE) out = out.replace(es, he);
  return out;
};
